import { VendorCreateState } from "../../reducers/vendor/VendorCreateReducer";

export type VendorCreationAction =
  | {
      type: "ON_CHANGE_VENDOR_CREATION_DATA";
      payload: [input: string, value: any];
    }
  | {
      type: "ON_REMOVE_VENDOR_CREATION_COMPANY_CODE";
      payload: [value: string];
    }
  | {
      type: "ON_REMOVE_VENDOR_CREATION_PURCH_ORG";
      payload: [value: string];
    }
  | {
    type: "ON_REMOVE_VENDOR_CREATION_APPROVER1";
    payload: [value: string];
  }
  | {
    type: "ON_REMOVE_VENDOR_CREATION_APPROVER2";
    payload: [value: string];
  }
  | {
    type: "ON_ORDERCURRENCY_UPDATE_VENDOR_CREATION";
    payload: [value: string];
  }
  | {
    type: "ON_REMOVE_VENDOR_CREATION_SETTLEMENT_CURRENCY";
    payload: [value: string];
  }
  | {
    type: "ON_REMOVE_VENDOR_CREATION_PAYMENT_METHOD";
    payload: [value: string];
  }
 |{
    type: "ON_REMOVE_VENDOR_CREATION_ONBOARDING_REASON";
    payload: [value: number];
  }
   |{
    type: "ON_REMOVE_VENDOR_CREATION_RMCategory";
    payload: [value: number];
  }
  |{
    type: "ON_REMOVE_VENDOR_CREATION_PROCUREMENT_CATEGORY";
    payload: [value: number];
  }
  |{
    type: "ON_REMOVE_VENDOR_CREATION_PROCUREMENT_SUB_CATEGORY";
    payload: [value: number];
  }
  | {
    type: "ON_SUCCESS_VENDOR_CREATION";
    payload: VendorCreateState;
  }
  | {
    type: "ON_SUCCESS_VENDOR_REQUEST_GET";
    payload: VendorCreateState;
  }
  | {
    type: "RESET_FOR_CREATE";
    payload: [requestor: string];
  };
    
function updateDataField(input: string, value: any): VendorCreationAction {
  return {
    type: "ON_CHANGE_VENDOR_CREATION_DATA",
    payload: [input, value],
  };
}

function removeFromCompanyCodes(value: string): VendorCreationAction {
  return {
    type: "ON_REMOVE_VENDOR_CREATION_COMPANY_CODE",
    payload: [value],
  };
}

function removeFromPoCodes(value: string): VendorCreationAction {
  return {
    type: "ON_REMOVE_VENDOR_CREATION_PURCH_ORG",
    payload: [value],
  };
}

function removeFromApporver1(value: string): VendorCreationAction {
  return {
    type: "ON_REMOVE_VENDOR_CREATION_APPROVER1",
    payload: [value],
  };
}

function removeFromApporver2(value: string): VendorCreationAction {
  return {
    type: "ON_REMOVE_VENDOR_CREATION_APPROVER2",
    payload: [value],
  };
}

function updateOrderCurrency(ordercurrency: string): VendorCreationAction {
  return {
    type: "ON_ORDERCURRENCY_UPDATE_VENDOR_CREATION",
    payload: [ordercurrency],
  };
}

function removeFromSettlementCurrency(value: string): VendorCreationAction {
  return {
    type: "ON_REMOVE_VENDOR_CREATION_SETTLEMENT_CURRENCY",
    payload: [value],
  };
}

function removeFromPrefPayMethod(value: string ): VendorCreationAction {
  return {
    type: "ON_REMOVE_VENDOR_CREATION_PAYMENT_METHOD",
    payload: [value],
  };
}
function removeFromOnBoardReason(value: number ): VendorCreationAction {
  return {
    type: "ON_REMOVE_VENDOR_CREATION_ONBOARDING_REASON",
    payload: [value],
  };
}
function removeFromRMCategory(value: number ): VendorCreationAction {
  return {
    type: "ON_REMOVE_VENDOR_CREATION_RMCategory",
    payload: [value],
  };
}
function removeFromProcurementCategory(value: number ): VendorCreationAction {
  return {
    type: "ON_REMOVE_VENDOR_CREATION_PROCUREMENT_CATEGORY",
    payload: [value],
  };
}
function removeFromProcurementSubcategory(value: number ): VendorCreationAction {
  return {
    type: "ON_REMOVE_VENDOR_CREATION_PROCUREMENT_SUB_CATEGORY",
    payload: [value],
  };
}
function updateForm1Details(vendor: VendorCreateState): VendorCreationAction {
  return {
    type: "ON_SUCCESS_VENDOR_CREATION",
    payload: vendor,
  };
}

function updateRequestDetails(vendor: VendorCreateState) :VendorCreationAction {
  return {
    type: "ON_SUCCESS_VENDOR_REQUEST_GET",
    payload: vendor,
  };
}

function resetRequestDetails(requestor: string) :VendorCreationAction {
  return {
    type: "RESET_FOR_CREATE",
    payload: [requestor],
  };
}

export const VendorCreationActions = {
  updateDataField,
  removeFromCompanyCodes,
  removeFromPoCodes,
  removeFromApporver1,
  removeFromApporver2,
  updateForm1Details,
  updateRequestDetails,
  resetRequestDetails,
  updateOrderCurrency,
  removeFromSettlementCurrency,
  removeFromPrefPayMethod,
  removeFromOnBoardReason,
  removeFromRMCategory,
  removeFromProcurementCategory,
  removeFromProcurementSubcategory
};
